import { render, staticRenderFns } from "./MypageWritingSubTitle.vue?vue&type=template&id=ba5936fa&"
import script from "./MypageWritingSubTitle.vue?vue&type=script&lang=js&"
export * from "./MypageWritingSubTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports